import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-ag-metric-cell-renderer',
  templateUrl: './ag-metric-cell-renderer.component.html',
  styleUrl: './ag-metric-cell-renderer.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AgMetricCellRendererComponent implements ICellRendererAngularComp {
  value: number = 0;

  agInit(params: ICellRendererParams): void {
    this.value = params.value ?? 0;
  }

  refresh(params: ICellRendererParams): boolean {
    this.value = params.value ?? 0;
    return true;
  }

  get hasValue(): boolean {
    return this.value > 0;
  }
}
